import crud from './helpers/crud';

const RECAPTURE_CAMPAIGNS_URL = '/api/v1/recapture_campaigns';
export const RECAPTURE_FILTERS_CONTRACT_VERSION = 3;

// Action Types
export const RECAPTURE_CAMPAIGNS = {
  FETCH_BEGIN: 'RECAPTURE_CAMPAIGNS_FETCH_BEGIN',
  FETCH_SUCCESS: 'RECAPTURE_CAMPAIGNS_FETCH_SUCCESS',
  FETCH_FAIL: 'RECAPTURE_CAMPAIGNS_FETCH_FAIL',
  CREATE_BEGIN: 'RECAPTURE_CAMPAIGN_CREATE_BEGIN',
  CREATE_SUCCESS: 'RECAPTURE_CAMPAIGN_CREATE_SUCCESS',
  CREATE_FAIL: 'RECAPTURE_CAMPAIGN_CREATE_FAIL',
  UPDATE_BEGIN: 'RECAPTURE_CAMPAIGN_UPDATE_BEGIN',
  UPDATE_SUCCESS: 'RECAPTURE_CAMPAIGN_UPDATE_SUCCESS',
  UPDATE_FAIL: 'RECAPTURE_CAMPAIGN_UPDATE_FAIL',
  ACTIVATE_BEGIN: 'RECAPTURE_CAMPAIGN_ACTIVATE_BEGIN',
  ACTIVATE_SUCCESS: 'RECAPTURE_CAMPAIGN_ACTIVATE_SUCCESS',
  ACTIVATE_FAIL: 'RECAPTURE_CAMPAIGN_ACTIVATE_FAIL',
  DEACTIVATE_BEGIN: 'RECAPTURE_CAMPAIGN_DEACTIVATE_BEGIN',
  DEACTIVATE_SUCCESS: 'RECAPTURE_CAMPAIGN_DEACTIVATE_SUCCESS',
  DEACTIVATE_FAIL: 'RECAPTURE_CAMPAIGN_DEACTIVATE_FAIL',
  REORDER_BEGIN: 'RECAPTURE_CAMPAIGNS_REORDER_BEGIN',
  REORDER_SUCCESS: 'RECAPTURE_CAMPAIGNS_REORDER_SUCCESS',
  REORDER_FAIL: 'RECAPTURE_CAMPAIGNS_REORDER_FAIL',
  EXISTENCE_FETCH_BEGIN: 'RECAPTURE_CAMPAIGN_EXISTENCE_FETCH_BEGIN',
  EXISTENCE_FETCH_SUCCESS: 'RECAPTURE_CAMPAIGN_EXISTENCE_FETCH_SUCCESS',
  EXISTENCE_FETCH_FAIL: 'RECAPTURE_CAMPAIGN_EXISTENCE_FETCH_FAIL',
};

export const RECAPTURE_CAMPAIGN_DRAFTS = {
  FETCH_BEGIN: 'RECAPTURE_CAMPAIGN_DRAFTS_FETCH_BEGIN',
  FETCH_SUCCESS: 'RECAPTURE_CAMPAIGN_DRAFTS_FETCH_SUCCESS',
  FETCH_FAIL: 'RECAPTURE_CAMPAIGN_DRAFTS_FETCH_FAIL',
  CREATE_BEGIN: 'RECAPTURE_CAMPAIGN_DRAFT_CREATE_BEGIN',
  CREATE_SUCCESS: 'RECAPTURE_CAMPAIGN_DRAFT_CREATE_SUCCESS',
  CREATE_FAIL: 'RECAPTURE_CAMPAIGN_DRAFT_CREATE_FAIL',
  UPDATE_BEGIN: 'RECAPTURE_CAMPAIGN_DRAFT_UPDATE_BEGIN',
  UPDATE_SUCCESS: 'RECAPTURE_CAMPAIGN_DRAFT_UPDATE_SUCCESS',
  UPDATE_FAIL: 'RECAPTURE_CAMPAIGN_DRAFT_UPDATE_FAIL',
  DELETE_BEGIN: 'RECAPTURE_CAMPAIGN_DRAFT_DELETE_BEGIN',
  DELETE_SUCCESS: 'RECAPTURE_CAMPAIGN_DRAFT_DELETE_SUCCESS',
  DELETE_FAIL: 'RECAPTURE_CAMPAIGN_DRAFT_DELETE_FAIL',
};

export const RECAPTURE_SCHEDULES = {
  FETCH_BEGIN: 'RECAPTURE_SCHEDULES_FETCH_BEGIN',
  FETCH_SUCCESS: 'RECAPTURE_SCHEDULES_FETCH_SUCCESS',
  FETCH_FAIL: 'RECAPTURE_SCHEDULES_FETCH_FAIL',
  CREATE_BEGIN: 'RECAPTURE_SCHEDULE_CREATE_BEGIN',
  CREATE_SUCCESS: 'RECAPTURE_SCHEDULE_CREATE_SUCCESS',
  CREATE_FAIL: 'RECAPTURE_SCHEDULE_CREATE_FAIL',
  UPDATE_BEGIN: 'RECAPTURE_SCHEDULE_UPDATE_BEGIN',
  UPDATE_SUCCESS: 'RECAPTURE_SCHEDULE_UPDATE_SUCCESS',
  UPDATE_FAIL: 'RECAPTURE_SCHEDULE_UPDATE_FAIL',
  ACTIVATE_BEGIN: 'RECAPTURE_SCHEDULE_ACTIVATE_BEGIN',
  ACTIVATE_SUCCESS: 'RECAPTURE_SCHEDULE_ACTIVATE_SUCCESS',
  ACTIVATE_FAIL: 'RECAPTURE_SCHEDULE_ACTIVATE_FAIL',
  DEACTIVATE_BEGIN: 'RECAPTURE_SCHEDULE_DEACTIVATE_BEGIN',
  DEACTIVATE_SUCCESS: 'RECAPTURE_SCHEDULE_DEACTIVATE_SUCCESS',
  DEACTIVATE_FAIL: 'RECAPTURE_SCHEDULE_DEACTIVATE_FAIL',
};

export const RECAPTURE_TEMPLATES = {
  FETCH_BEGIN: 'RECAPTURE_TEMPLATES_FETCH_BEGIN',
  FETCH_SUCCESS: 'RECAPTURE_TEMPLATES_FETCH_SUCCESS',
  FETCH_FAIL: 'RECAPTURE_TEMPLATES_FETCH_FAIL',
  CREATE_BEGIN: 'RECAPTURE_TEMPLATE_CREATE_BEGIN',
  CREATE_SUCCESS: 'RECAPTURE_TEMPLATE_CREATE_SUCCESS',
  CREATE_FAIL: 'RECAPTURE_TEMPLATE_CREATE_FAIL',
  UPDATE_BEGIN: 'RECAPTURE_TEMPLATE_UPDATE_BEGIN',
  UPDATE_SUCCESS: 'RECAPTURE_TEMPLATE_UPDATE_SUCCESS',
  UPDATE_FAIL: 'RECAPTURE_TEMPLATE_UPDATE_FAIL',
  ACTIVATE_BEGIN: 'RECAPTURE_TEMPLATE_ACTIVATE_BEGIN',
  ACTIVATE_SUCCESS: 'RECAPTURE_TEMPLATE_ACTIVATE_SUCCESS',
  ACTIVATE_FAIL: 'RECAPTURE_TEMPLATE_ACTIVATE_FAIL',
  DEACTIVATE_BEGIN: 'RECAPTURE_TEMPLATE_DEACTIVATE_BEGIN',
  DEACTIVATE_SUCCESS: 'RECAPTURE_TEMPLATE_DEACTIVATE_SUCCESS',
  DEACTIVATE_FAIL: 'RECAPTURE_TEMPLATE_DEACTIVATE_FAIL',
  DUPLICATE_BEGIN: 'RECAPTURE_TEMPLATE_DUPLICATE_BEGIN',
  DUPLICATE_SUCCESS: 'RECAPTURE_TEMPLATE_DUPLICATE_SUCCESS',
  DUPLICATE_FAIL: 'RECAPTURE_TEMPLATE_DUPLICATE_FAIL',
};

export const RECAPTURE_EMAIL_TEMPLATES = {
  FETCH_BEGIN: 'RECAPTURE_EMAIL_TEMPLATES_FETCH_BEGIN',
  FETCH_SUCCESS: 'RECAPTURE_EMAIL_TEMPLATES_FETCH_SUCCESS',
  FETCH_FAIL: 'RECAPTURE_EMAIL_TEMPLATES_FETCH_FAIL',
  FETCH_ONE_BEGIN: 'RECAPTURE_EMAIL_TEMPLATE_FETCH_ONE_BEGIN',
  FETCH_ONE_SUCCESS: 'RECAPTURE_EMAIL_TEMPLATE_FETCH_ONE_SUCCESS',
  FETCH_ONE_FAIL: 'RECAPTURE_EMAIL_TEMPLATE_FETCH_ONE_FAIL',
  FETCH_ONE_INVALIDATE: 'RECAPTURE_EMAIL_TEMPLATE_FETCH_ONE_INVALIDATE',
  CREATE_BEGIN: 'RECAPTURE_EMAIL_TEMPLATE_CREATE_BEGIN',
  CREATE_SUCCESS: 'RECAPTURE_EMAIL_TEMPLATE_CREATE_SUCCESS',
  CREATE_FAIL: 'RECAPTURE_EMAIL_TEMPLATE_CREATE_FAIL',
  UPDATE_BEGIN: 'RECAPTURE_EMAIL_TEMPLATE_UPDATE_BEGIN',
  UPDATE_SUCCESS: 'RECAPTURE_EMAIL_TEMPLATE_UPDATE_SUCCESS',
  UPDATE_FAIL: 'RECAPTURE_EMAIL_TEMPLATE_UPDATE_FAIL',
  ACTIVATE_BEGIN: 'RECAPTURE_EMAIL_TEMPLATE_ACTIVATE_BEGIN',
  ACTIVATE_SUCCESS: 'RECAPTURE_EMAIL_TEMPLATE_ACTIVATE_SUCCESS',
  ACTIVATE_FAIL: 'RECAPTURE_EMAIL_TEMPLATE_ACTIVATE_FAIL',
  DEACTIVATE_BEGIN: 'RECAPTURE_EMAIL_TEMPLATE_DEACTIVATE_BEGIN',
  DEACTIVATE_SUCCESS: 'RECAPTURE_EMAIL_TEMPLATE_DEACTIVATE_SUCCESS',
  DEACTIVATE_FAIL: 'RECAPTURE_EMAIL_TEMPLATE_DEACTIVATE_FAIL',
  MEMBER_PREVIEW_BEGIN: 'RECAPTURE_EMAIL_TEMPLATE_MEMBER_PREVIEW_BEGIN',
  MEMBER_PREVIEW_SUCCESS: 'RECAPTURE_EMAIL_TEMPLATE_MEMBER_PREVIEW_SUCCESS',
  MEMBER_PREVIEW_FAIL: 'RECAPTURE_EMAIL_TEMPLATE_MEMBER_PREVIEW_FAIL',
};

export const RECAPTURE_EMAIL_SETTINGS = {
  FETCH_BEGIN: 'RECAPTURE_EMAIL_SETTINGS_FETCH_BEGIN',
  FETCH_SUCCESS: 'RECAPTURE_EMAIL_SETTINGS_FETCH_SUCCESS',
  FETCH_FAIL: 'RECAPTURE_EMAIL_SETTINGS_FETCH_FAIL',
  SAVE_BEGIN: 'RECAPTURE_EMAIL_SETTINGS_SAVE_BEGIN',
  SAVE_SUCCESS: 'RECAPTURE_EMAIL_SETTINGS_SAVE_SUCCESS',
  SAVE_FAIL: 'RECAPTURE_EMAIL_SETTINGS_SAVE_FAIL',
};

export const RECAPTURE_CALL_TEMPLATES = {
  FETCH_BEGIN: 'RECAPTURE_CALL_TEMPLATES_FETCH_BEGIN',
  FETCH_SUCCESS: 'RECAPTURE_CALL_TEMPLATES_FETCH_SUCCESS',
  FETCH_FAIL: 'RECAPTURE_CALL_TEMPLATES_FETCH_FAIL',
  CREATE_BEGIN: 'RECAPTURE_CALL_TEMPLATE_CREATE_BEGIN',
  CREATE_SUCCESS: 'RECAPTURE_CALL_TEMPLATE_CREATE_SUCCESS',
  CREATE_FAIL: 'RECAPTURE_CALL_TEMPLATE_CREATE_FAIL',
  UPDATE_BEGIN: 'RECAPTURE_CALL_TEMPLATE_UPDATE_BEGIN',
  UPDATE_SUCCESS: 'RECAPTURE_CALL_TEMPLATE_UPDATE_SUCCESS',
  UPDATE_FAIL: 'RECAPTURE_CALL_TEMPLATE_UPDATE_FAIL',
  ACTIVATE_BEGIN: 'RECAPTURE_CALL_TEMPLATE_ACTIVATE_BEGIN',
  ACTIVATE_SUCCESS: 'RECAPTURE_CALL_TEMPLATE_ACTIVATE_SUCCESS',
  ACTIVATE_FAIL: 'RECAPTURE_CALL_TEMPLATE_ACTIVATE_FAIL',
  DEACTIVATE_BEGIN: 'RECAPTURE_CALL_TEMPLATE_DEACTIVATE_BEGIN',
  DEACTIVATE_SUCCESS: 'RECAPTURE_CALL_TEMPLATE_DEACTIVATE_SUCCESS',
  DEACTIVATE_FAIL: 'RECAPTURE_CALL_TEMPLATE_DEACTIVATE_FAIL',
  DUPLICATE_BEGIN: 'RECAPTURE_CALL_TEMPLATE_DUPLICATE_BEGIN',
  DUPLICATE_SUCCESS: 'RECAPTURE_CALL_TEMPLATE_DUPLICATE_SUCCESS',
  DUPLICATE_FAIL: 'RECAPTURE_CALL_TEMPLATE_DUPLICATE_FAIL',
};

export const RECAPTURE_CODE_GROUPS = {
  FETCH_BEGIN: 'RECAPTURE_CODE_GROUPS_FETCH_BEGIN',
  FETCH_SUCCESS: 'RECAPTURE_CODE_GROUPS_FETCH_SUCCESS',
  FETCH_FAIL: 'RECAPTURE_CODE_GROUPS_FETCH_FAIL',
  FETCH_ONE_BEGIN: 'RECAPTURE_CODE_GROUP_FETCH_ONE_BEGIN',
  FETCH_ONE_SUCCESS: 'RECAPTURE_CODE_GROUP_FETCH_ONE_SUCCESS',
  FETCH_ONE_FAIL: 'RECAPTURE_CODE_GROUP_FETCH_ONE_FAIL',
  CREATE_BEGIN: 'RECAPTURE_CODE_GROUP_CREATE_BEGIN',
  CREATE_SUCCESS: 'RECAPTURE_CODE_GROUP_CREATE_SUCCESS',
  CREATE_FAIL: 'RECAPTURE_CODE_GROUP_CREATE_FAIL',
  UPDATE_BEGIN: 'RECAPTURE_CODE_GROUP_UPDATE_BEGIN',
  UPDATE_SUCCESS: 'RECAPTURE_CODE_GROUP_UPDATE_SUCCESS',
  UPDATE_FAIL: 'RECAPTURE_CODE_GROUP_UPDATE_FAIL',
  ACTIVATE_BEGIN: 'RECAPTURE_CODE_GROUP_ACTIVATE_BEGIN',
  ACTIVATE_SUCCESS: 'RECAPTURE_CODE_GROUP_ACTIVATE_SUCCESS',
  ACTIVATE_FAIL: 'RECAPTURE_CODE_GROUP_ACTIVATE_FAIL',
  DEACTIVATE_BEGIN: 'RECAPTURE_CODE_GROUP_DEACTIVATE_BEGIN',
  DEACTIVATE_SUCCESS: 'RECAPTURE_CODE_GROUP_DEACTIVATE_SUCCESS',
  DEACTIVATE_FAIL: 'RECAPTURE_CODE_GROUP_DEACTIVATE_FAIL',
};

export const RECAPTURE_APPOINTMENT_TYPE_GROUPS = {
  FETCH_BEGIN: 'RECAPTURE_APPOINTMENT_TYPE_GROUPS_FETCH_BEGIN',
  FETCH_SUCCESS: 'RECAPTURE_APPOINTMENT_TYPE_GROUPS_FETCH_SUCCESS',
  FETCH_FAIL: 'RECAPTURE_APPOINTMENT_TYPE_GROUPS_FETCH_FAIL',
  FETCH_ONE_BEGIN: 'RECAPTURE_APPOINTMENT_TYPE_GROUP_FETCH_ONE_BEGIN',
  FETCH_ONE_SUCCESS: 'RECAPTURE_APPOINTMENT_TYPE_GROUP_FETCH_ONE_SUCCESS',
  FETCH_ONE_FAIL: 'RECAPTURE_APPOINTMENT_TYPE_GROUP_FETCH_ONE_FAIL',
  CREATE_BEGIN: 'RECAPTURE_APPOINTMENT_TYPE_GROUP_CREATE_BEGIN',
  CREATE_SUCCESS: 'RECAPTURE_APPOINTMENT_TYPE_GROUP_CREATE_SUCCESS',
  CREATE_FAIL: 'RECAPTURE_APPOINTMENT_TYPE_GROUP_CREATE_FAIL',
  UPDATE_BEGIN: 'RECAPTURE_APPOINTMENT_TYPE_GROUP_UPDATE_BEGIN',
  UPDATE_SUCCESS: 'RECAPTURE_APPOINTMENT_TYPE_GROUP_UPDATE_SUCCESS',
  UPDATE_FAIL: 'RECAPTURE_APPOINTMENT_TYPE_GROUP_UPDATE_FAIL',
  ACTIVATE_BEGIN: 'RECAPTURE_APPOINTMENT_TYPE_GROUP_ACTIVATE_BEGIN',
  ACTIVATE_SUCCESS: 'RECAPTURE_APPOINTMENT_TYPE_GROUP_ACTIVATE_SUCCESS',
  ACTIVATE_FAIL: 'RECAPTURE_APPOINTMENT_TYPE_GROUP_ACTIVATE_FAIL',
  DEACTIVATE_BEGIN: 'RECAPTURE_APPOINTMENT_TYPE_GROUP_DEACTIVATE_BEGIN',
  DEACTIVATE_SUCCESS: 'RECAPTURE_APPOINTMENT_TYPE_GROUP_DEACTIVATE_SUCCESS',
  DEACTIVATE_FAIL: 'RECAPTURE_APPOINTMENT_TYPE_GROUP_DEACTIVATE_FAIL',
};

export const RECAPTURE_SMS_PROFILES = {
  FETCH_BEGIN: 'RECAPTURE_SMS_PROFILES_FETCH_BEGIN',
  FETCH_SUCCESS: 'RECAPTURE_SMS_PROFILES_FETCH_SUCCESS',
  FETCH_FAIL: 'RECAPTURE_SMS_PROFILES_FETCH_FAIL',
};

// Clear errors action
export const CLEAR_RECAPTURE_ERRORS = 'CLEAR_RECAPTURE_ERRORS';

let nextRecaptureEmailRequestId = 0;

export const allocateRecaptureEmailRequestId = () => {
  nextRecaptureEmailRequestId += 1;
  return nextRecaptureEmailRequestId;
};

const recaptureEmailRequestMeta = (requestId, metadata = {}) => ({
  ...metadata,
  requestId,
  // `crud` must not replay BEGIN when its transport retries. Replaying an old
  // BEGIN can reclaim loading/error ownership after a newer editor or settings
  // mutation has already become authoritative.
  requestOwnership: { kind: 'recapture-email', requestId },
});

export const clearRecaptureErrors = () => (dispatch) => {
  dispatch({ type: CLEAR_RECAPTURE_ERRORS });
};

// ============ CAMPAIGNS ============

export const fetchCampaigns = (active = true) => crud({
  dispatch: {
    begin: RECAPTURE_CAMPAIGNS.FETCH_BEGIN,
    fail: RECAPTURE_CAMPAIGNS.FETCH_FAIL,
    end: RECAPTURE_CAMPAIGNS.FETCH_SUCCESS,
  },
  method: 'GET',
  url: `${RECAPTURE_CAMPAIGNS_URL}?active=${active}`,
});

export const fetchCampaignExistence = () => crud({
  dispatch: {
    begin: RECAPTURE_CAMPAIGNS.EXISTENCE_FETCH_BEGIN,
    fail: RECAPTURE_CAMPAIGNS.EXISTENCE_FETCH_FAIL,
    end: RECAPTURE_CAMPAIGNS.EXISTENCE_FETCH_SUCCESS,
  },
  method: 'GET',
  url: `${RECAPTURE_CAMPAIGNS_URL}?active=all`,
});

// draftId (ENG-3285): the saved draft this launch came from. Sent as a
// top-level param — the server consumes (destroys) that draft in the same
// transaction as the create. It must stay OUTSIDE recapture_campaign, whose
// strict allow-list would 400 on it.
export const createCampaign = (campaignData, onSuccess, { draftId = null } = {}) => crud({
  dispatch: {
    begin: RECAPTURE_CAMPAIGNS.CREATE_BEGIN,
    fail: RECAPTURE_CAMPAIGNS.CREATE_FAIL,
    end: RECAPTURE_CAMPAIGNS.CREATE_SUCCESS,
  },
  method: 'POST',
  url: RECAPTURE_CAMPAIGNS_URL,
  data: {
    recapture_campaign: campaignData,
    filters_contract_version: RECAPTURE_FILTERS_CONTRACT_VERSION,
    ...(draftId ? { draft_id: draftId } : {}),
  },
  onSuccess,
});

// ============ CAMPAIGN DRAFTS (ENG-3285) ============

const RECAPTURE_CAMPAIGN_DRAFTS_URL = '/api/v1/recapture_campaign_drafts';

export const fetchCampaignDrafts = () => crud({
  dispatch: {
    begin: RECAPTURE_CAMPAIGN_DRAFTS.FETCH_BEGIN,
    fail: RECAPTURE_CAMPAIGN_DRAFTS.FETCH_FAIL,
    end: RECAPTURE_CAMPAIGN_DRAFTS.FETCH_SUCCESS,
  },
  method: 'GET',
  url: RECAPTURE_CAMPAIGN_DRAFTS_URL,
});

export const createCampaignDraft = (draftData, onSuccess) => crud({
  dispatch: {
    begin: RECAPTURE_CAMPAIGN_DRAFTS.CREATE_BEGIN,
    fail: RECAPTURE_CAMPAIGN_DRAFTS.CREATE_FAIL,
    end: RECAPTURE_CAMPAIGN_DRAFTS.CREATE_SUCCESS,
  },
  method: 'POST',
  url: RECAPTURE_CAMPAIGN_DRAFTS_URL,
  data: {
    recapture_campaign_draft: draftData,
    filters_contract_version: RECAPTURE_FILTERS_CONTRACT_VERSION,
  },
  onSuccess,
});

export const updateCampaignDraft = (id, draftData, onSuccess) => crud({
  dispatch: {
    begin: RECAPTURE_CAMPAIGN_DRAFTS.UPDATE_BEGIN,
    fail: RECAPTURE_CAMPAIGN_DRAFTS.UPDATE_FAIL,
    end: RECAPTURE_CAMPAIGN_DRAFTS.UPDATE_SUCCESS,
  },
  method: 'PATCH',
  url: `${RECAPTURE_CAMPAIGN_DRAFTS_URL}/${id}`,
  data: {
    recapture_campaign_draft: draftData,
    filters_contract_version: RECAPTURE_FILTERS_CONTRACT_VERSION,
  },
  onSuccess,
});

// DELETE returns 204 with no body, so the reducer removes the row by the id
// carried on the action meta.
export const deleteCampaignDraft = (id, onSuccess) => crud({
  dispatch: {
    begin: RECAPTURE_CAMPAIGN_DRAFTS.DELETE_BEGIN,
    fail: RECAPTURE_CAMPAIGN_DRAFTS.DELETE_FAIL,
    end: RECAPTURE_CAMPAIGN_DRAFTS.DELETE_SUCCESS,
    meta: { id },
  },
  method: 'DELETE',
  url: `${RECAPTURE_CAMPAIGN_DRAFTS_URL}/${id}`,
  onSuccess,
});

export const updateCampaign = (id, campaignData, onSuccess) => crud({
  dispatch: {
    begin: RECAPTURE_CAMPAIGNS.UPDATE_BEGIN,
    fail: RECAPTURE_CAMPAIGNS.UPDATE_FAIL,
    end: RECAPTURE_CAMPAIGNS.UPDATE_SUCCESS,
  },
  method: 'PATCH',
  url: `/api/v1/recapture_campaigns/${id}`,
  data: {
    recapture_campaign: campaignData,
    filters_contract_version: RECAPTURE_FILTERS_CONTRACT_VERSION,
  },
  onSuccess,
});

export const activateCampaign = (id, onSuccess) => crud({
  dispatch: {
    begin: RECAPTURE_CAMPAIGNS.ACTIVATE_BEGIN,
    fail: RECAPTURE_CAMPAIGNS.ACTIVATE_FAIL,
    end: RECAPTURE_CAMPAIGNS.ACTIVATE_SUCCESS,
  },
  method: 'PATCH',
  url: `/api/v1/recapture_campaigns/${id}/activate`,
  onSuccess,
});

export const deactivateCampaign = (id, onSuccess) => crud({
  dispatch: {
    begin: RECAPTURE_CAMPAIGNS.DEACTIVATE_BEGIN,
    fail: RECAPTURE_CAMPAIGNS.DEACTIVATE_FAIL,
    end: RECAPTURE_CAMPAIGNS.DEACTIVATE_SUCCESS,
  },
  method: 'PATCH',
  url: `/api/v1/recapture_campaigns/${id}/deactivate`,
  onSuccess,
});

export const reorderCampaigns = (campaignIds, onSuccess) => crud({
  dispatch: {
    begin: RECAPTURE_CAMPAIGNS.REORDER_BEGIN,
    fail: RECAPTURE_CAMPAIGNS.REORDER_FAIL,
    end: RECAPTURE_CAMPAIGNS.REORDER_SUCCESS,
  },
  method: 'PATCH',
  url: '/api/v1/recapture_campaigns/reorder',
  data: { campaign_ids: campaignIds },
  onSuccess,
});

// ============ SCHEDULES ============

export const fetchSchedules = (active = true) => crud({
  dispatch: {
    begin: RECAPTURE_SCHEDULES.FETCH_BEGIN,
    fail: RECAPTURE_SCHEDULES.FETCH_FAIL,
    end: RECAPTURE_SCHEDULES.FETCH_SUCCESS,
  },
  method: 'GET',
  url: `/api/v1/recapture_schedules?active=${active}`,
});

export const createSchedule = (scheduleData, onSuccess) => crud({
  dispatch: {
    begin: RECAPTURE_SCHEDULES.CREATE_BEGIN,
    fail: RECAPTURE_SCHEDULES.CREATE_FAIL,
    end: RECAPTURE_SCHEDULES.CREATE_SUCCESS,
  },
  method: 'POST',
  url: '/api/v1/recapture_schedules',
  data: { recapture_schedule: scheduleData },
  onSuccess,
});

export const updateSchedule = (id, scheduleData, onSuccess) => crud({
  dispatch: {
    begin: RECAPTURE_SCHEDULES.UPDATE_BEGIN,
    fail: RECAPTURE_SCHEDULES.UPDATE_FAIL,
    end: RECAPTURE_SCHEDULES.UPDATE_SUCCESS,
  },
  method: 'PATCH',
  url: `/api/v1/recapture_schedules/${id}`,
  data: { recapture_schedule: scheduleData },
  onSuccess,
});

export const activateSchedule = (id, onSuccess) => crud({
  dispatch: {
    begin: RECAPTURE_SCHEDULES.ACTIVATE_BEGIN,
    fail: RECAPTURE_SCHEDULES.ACTIVATE_FAIL,
    end: RECAPTURE_SCHEDULES.ACTIVATE_SUCCESS,
  },
  method: 'PATCH',
  url: `/api/v1/recapture_schedules/${id}/activate`,
  onSuccess,
});

export const deactivateSchedule = (id, onSuccess) => crud({
  dispatch: {
    begin: RECAPTURE_SCHEDULES.DEACTIVATE_BEGIN,
    fail: RECAPTURE_SCHEDULES.DEACTIVATE_FAIL,
    end: RECAPTURE_SCHEDULES.DEACTIVATE_SUCCESS,
  },
  method: 'PATCH',
  url: `/api/v1/recapture_schedules/${id}/deactivate`,
  onSuccess,
});

// ============ TEMPLATES ============

export const fetchTemplates = (active = true) => crud({
  dispatch: {
    begin: RECAPTURE_TEMPLATES.FETCH_BEGIN,
    fail: RECAPTURE_TEMPLATES.FETCH_FAIL,
    end: RECAPTURE_TEMPLATES.FETCH_SUCCESS,
  },
  method: 'GET',
  url: `/api/v1/recapture_message_templates?active=${active}`,
});

export const fetchCallTemplates = (active = true) => crud({
  dispatch: {
    begin: RECAPTURE_CALL_TEMPLATES.FETCH_BEGIN,
    fail: RECAPTURE_CALL_TEMPLATES.FETCH_FAIL,
    end: RECAPTURE_CALL_TEMPLATES.FETCH_SUCCESS,
  },
  method: 'GET',
  url: `/api/v1/recapture_call_templates?active=${active}`,
});

export const createCallTemplate = (templateData, onSuccess) => crud({
  dispatch: {
    begin: RECAPTURE_CALL_TEMPLATES.CREATE_BEGIN,
    fail: RECAPTURE_CALL_TEMPLATES.CREATE_FAIL,
    end: RECAPTURE_CALL_TEMPLATES.CREATE_SUCCESS,
  },
  method: 'POST',
  url: '/api/v1/recapture_call_templates',
  data: { recapture_call_template: templateData },
  onSuccess,
});

export const updateCallTemplate = (id, templateData, onSuccess) => crud({
  dispatch: {
    begin: RECAPTURE_CALL_TEMPLATES.UPDATE_BEGIN,
    fail: RECAPTURE_CALL_TEMPLATES.UPDATE_FAIL,
    end: RECAPTURE_CALL_TEMPLATES.UPDATE_SUCCESS,
  },
  method: 'PATCH',
  url: `/api/v1/recapture_call_templates/${id}`,
  data: { recapture_call_template: templateData },
  onSuccess,
});

export const activateCallTemplate = (id, onSuccess) => crud({
  dispatch: {
    begin: RECAPTURE_CALL_TEMPLATES.ACTIVATE_BEGIN,
    fail: RECAPTURE_CALL_TEMPLATES.ACTIVATE_FAIL,
    end: RECAPTURE_CALL_TEMPLATES.ACTIVATE_SUCCESS,
  },
  method: 'PATCH',
  url: `/api/v1/recapture_call_templates/${id}/activate`,
  onSuccess,
});

export const deactivateCallTemplate = (id, onSuccess) => crud({
  dispatch: {
    begin: RECAPTURE_CALL_TEMPLATES.DEACTIVATE_BEGIN,
    fail: RECAPTURE_CALL_TEMPLATES.DEACTIVATE_FAIL,
    end: RECAPTURE_CALL_TEMPLATES.DEACTIVATE_SUCCESS,
  },
  method: 'PATCH',
  url: `/api/v1/recapture_call_templates/${id}/deactivate`,
  onSuccess,
});

// INVARIANT: `retryOnUnavailable: false` on both duplicate actions. The
// endpoints commit the copy and then serialize it, and serialization issues its
// own reads (`frontend_object` loads the prompt profile, `object` the template's
// associations). A transient database failure in that window is rendered as a
// 503 *after* the copy is durable, and each replay mints another copy under a
// freshly generated "(Copy N)" name -- the unique index cannot arbitrate,
// because the name is different every time, and recapture templates have no
// destroy route, so the junk copies are permanent. `create` is not exposed this
// way: a replay of it collides on the name the user typed.
export const duplicateCallTemplate = (id, onSuccess) => crud({
  dispatch: {
    begin: RECAPTURE_CALL_TEMPLATES.DUPLICATE_BEGIN,
    fail: RECAPTURE_CALL_TEMPLATES.DUPLICATE_FAIL,
    end: RECAPTURE_CALL_TEMPLATES.DUPLICATE_SUCCESS,
  },
  method: 'POST',
  url: `/api/v1/recapture_call_templates/${id}/duplicate`,
  retryOnUnavailable: false,
  onSuccess,
});

export const createTemplate = (templateData, onSuccess) => crud({
  dispatch: {
    begin: RECAPTURE_TEMPLATES.CREATE_BEGIN,
    fail: RECAPTURE_TEMPLATES.CREATE_FAIL,
    end: RECAPTURE_TEMPLATES.CREATE_SUCCESS,
  },
  method: 'POST',
  url: '/api/v1/recapture_message_templates',
  data: { recapture_message_template: templateData },
  onSuccess,
});

export const updateTemplate = (id, templateData, onSuccess) => crud({
  dispatch: {
    begin: RECAPTURE_TEMPLATES.UPDATE_BEGIN,
    fail: RECAPTURE_TEMPLATES.UPDATE_FAIL,
    end: RECAPTURE_TEMPLATES.UPDATE_SUCCESS,
  },
  method: 'PATCH',
  url: `/api/v1/recapture_message_templates/${id}`,
  data: { recapture_message_template: templateData },
  onSuccess,
});

export const activateTemplate = (id, onSuccess) => crud({
  dispatch: {
    begin: RECAPTURE_TEMPLATES.ACTIVATE_BEGIN,
    fail: RECAPTURE_TEMPLATES.ACTIVATE_FAIL,
    end: RECAPTURE_TEMPLATES.ACTIVATE_SUCCESS,
  },
  method: 'PATCH',
  url: `/api/v1/recapture_message_templates/${id}/activate`,
  onSuccess,
});

export const deactivateTemplate = (id, onSuccess) => crud({
  dispatch: {
    begin: RECAPTURE_TEMPLATES.DEACTIVATE_BEGIN,
    fail: RECAPTURE_TEMPLATES.DEACTIVATE_FAIL,
    end: RECAPTURE_TEMPLATES.DEACTIVATE_SUCCESS,
  },
  method: 'PATCH',
  url: `/api/v1/recapture_message_templates/${id}/deactivate`,
  onSuccess,
});

// See `duplicateCallTemplate` for why this POST opts out of the 503 retry loop.
export const duplicateTemplate = (id, onSuccess) => crud({
  dispatch: {
    begin: RECAPTURE_TEMPLATES.DUPLICATE_BEGIN,
    fail: RECAPTURE_TEMPLATES.DUPLICATE_FAIL,
    end: RECAPTURE_TEMPLATES.DUPLICATE_SUCCESS,
  },
  method: 'POST',
  url: `/api/v1/recapture_message_templates/${id}/duplicate`,
  retryOnUnavailable: false,
  onSuccess,
});

// ============ EMAIL TEMPLATES (ENG-3105 U2.2) ============

export const fetchEmailTemplates = () => {
  const requestId = allocateRecaptureEmailRequestId();

  return crud({
    dispatch: {
      begin: RECAPTURE_EMAIL_TEMPLATES.FETCH_BEGIN,
      fail: RECAPTURE_EMAIL_TEMPLATES.FETCH_FAIL,
      end: RECAPTURE_EMAIL_TEMPLATES.FETCH_SUCCESS,
      meta: recaptureEmailRequestMeta(requestId),
    },
    method: 'GET',
    url: '/api/v1/recapture_email_templates',
  });
};

export const fetchEmailTemplate = (id, requestId = allocateRecaptureEmailRequestId()) => crud({
  dispatch: {
    begin: RECAPTURE_EMAIL_TEMPLATES.FETCH_ONE_BEGIN,
    fail: RECAPTURE_EMAIL_TEMPLATES.FETCH_ONE_FAIL,
    end: RECAPTURE_EMAIL_TEMPLATES.FETCH_ONE_SUCCESS,
    meta: recaptureEmailRequestMeta(requestId, { templateId: id }),
  },
  method: 'GET',
  url: `/api/v1/recapture_email_templates/${id}`,
});

export const invalidateEmailTemplateDetail = (
  requestId = allocateRecaptureEmailRequestId(),
) => (dispatch) => {
  dispatch({
    type: RECAPTURE_EMAIL_TEMPLATES.FETCH_ONE_INVALIDATE,
    meta: { requestId },
  });
};

export const fetchEmailSettings = () => {
  const requestId = allocateRecaptureEmailRequestId();
  return crud({
    dispatch: {
      begin: RECAPTURE_EMAIL_SETTINGS.FETCH_BEGIN,
      fail: RECAPTURE_EMAIL_SETTINGS.FETCH_FAIL,
      end: RECAPTURE_EMAIL_SETTINGS.FETCH_SUCCESS,
      meta: recaptureEmailRequestMeta(requestId),
    },
    method: 'GET',
    url: '/api/v1/recapture_email_setting',
  });
};

export const saveEmailSettings = (settingsData, onSuccess) => crud({
  dispatch: {
    begin: RECAPTURE_EMAIL_SETTINGS.SAVE_BEGIN,
    fail: RECAPTURE_EMAIL_SETTINGS.SAVE_FAIL,
    end: RECAPTURE_EMAIL_SETTINGS.SAVE_SUCCESS,
  },
  method: 'PATCH',
  url: '/api/v1/recapture_email_setting',
  data: { recapture_email_setting: settingsData },
  onSuccess,
});

export const createEmailTemplate = (templateData, onSuccess) => crud({
  dispatch: {
    begin: RECAPTURE_EMAIL_TEMPLATES.CREATE_BEGIN,
    fail: RECAPTURE_EMAIL_TEMPLATES.CREATE_FAIL,
    end: RECAPTURE_EMAIL_TEMPLATES.CREATE_SUCCESS,
  },
  method: 'POST',
  url: '/api/v1/recapture_email_templates',
  data: { recapture_email_template: templateData },
  onSuccess,
});

export const updateEmailTemplate = (id, templateData, onSuccess) => crud({
  dispatch: {
    begin: RECAPTURE_EMAIL_TEMPLATES.UPDATE_BEGIN,
    fail: RECAPTURE_EMAIL_TEMPLATES.UPDATE_FAIL,
    end: RECAPTURE_EMAIL_TEMPLATES.UPDATE_SUCCESS,
    meta: { templateId: id },
  },
  method: 'PATCH',
  url: `/api/v1/recapture_email_templates/${id}`,
  data: { recapture_email_template: templateData },
  onSuccess,
});

export const activateEmailTemplate = (id, onSuccess) => crud({
  dispatch: {
    begin: RECAPTURE_EMAIL_TEMPLATES.ACTIVATE_BEGIN,
    fail: RECAPTURE_EMAIL_TEMPLATES.ACTIVATE_FAIL,
    end: RECAPTURE_EMAIL_TEMPLATES.ACTIVATE_SUCCESS,
  },
  method: 'PATCH',
  url: `/api/v1/recapture_email_templates/${id}/activate`,
  onSuccess,
});

export const deactivateEmailTemplate = (id, onSuccess) => crud({
  dispatch: {
    begin: RECAPTURE_EMAIL_TEMPLATES.DEACTIVATE_BEGIN,
    fail: RECAPTURE_EMAIL_TEMPLATES.DEACTIVATE_FAIL,
    end: RECAPTURE_EMAIL_TEMPLATES.DEACTIVATE_SUCCESS,
  },
  method: 'PATCH',
  url: `/api/v1/recapture_email_templates/${id}/deactivate`,
  onSuccess,
});

export const previewEmailTemplateMember = (
  id,
  revisionId,
  requestId,
  onSuccess,
) => {
  const resolvedRequestId = requestId === undefined
    ? allocateRecaptureEmailRequestId()
    : requestId;
  return crud({
    dispatch: {
      begin: RECAPTURE_EMAIL_TEMPLATES.MEMBER_PREVIEW_BEGIN,
      fail: RECAPTURE_EMAIL_TEMPLATES.MEMBER_PREVIEW_FAIL,
      end: RECAPTURE_EMAIL_TEMPLATES.MEMBER_PREVIEW_SUCCESS,
      meta: recaptureEmailRequestMeta(resolvedRequestId, { templateId: id, revisionId }),
    },
    method: 'GET',
    url: `/api/v1/recapture_email_templates/${id}/preview`,
    onSuccess,
  });
};

// ============ PATIENT GROUPS ============

export const PATIENT_GROUP_TYPES = {
  DIAGNOSIS_CODE: 'diagnosis_code',
  APPOINTMENT_TYPE: 'appointment_type',
};

export const PATIENT_GROUP_RESOURCE_TYPES = {
  diagnosis_code: {
    type: PATIENT_GROUP_TYPES.DIAGNOSIS_CODE,
    endpoint: '/api/v1/recapture_code_groups',
    payloadKey: 'recapture_code_group',
    collectionPayloadKey: 'code_groups',
    detailPayloadKey: 'code_group',
    actionTypes: RECAPTURE_CODE_GROUPS,
    state: {
      collection: 'codeGroups',
      collectionLoading: 'codeGroupsLoading',
      collectionError: 'codeGroupsError',
      saving: 'codeGroupSaving',
      error: 'codeGroupError',
      current: 'currentCodeGroup',
      currentLoading: 'currentCodeGroupLoading',
    },
    actions: {
      fetchList: 'fetchCodeGroups',
      fetchOne: 'fetchCodeGroup',
      create: 'createCodeGroup',
      update: 'updateCodeGroup',
      activate: 'activateCodeGroup',
      deactivate: 'deactivateCodeGroup',
    },
  },
  appointment_type: {
    type: PATIENT_GROUP_TYPES.APPOINTMENT_TYPE,
    endpoint: '/api/v1/recapture_appointment_type_groups',
    payloadKey: 'recapture_appointment_type_group',
    collectionPayloadKey: 'appointment_type_groups',
    detailPayloadKey: 'appointment_type_group',
    actionTypes: RECAPTURE_APPOINTMENT_TYPE_GROUPS,
    state: {
      collection: 'appointmentTypeGroups',
      collectionLoading: 'appointmentTypeGroupsLoading',
      collectionError: 'appointmentTypeGroupsError',
      saving: 'appointmentTypeGroupSaving',
      error: 'appointmentTypeGroupError',
      current: 'currentAppointmentTypeGroup',
      currentLoading: 'currentAppointmentTypeGroupLoading',
    },
    actions: {
      fetchList: 'fetchAppointmentTypeGroups',
      fetchOne: 'fetchAppointmentTypeGroup',
      create: 'createAppointmentTypeGroup',
      update: 'updateAppointmentTypeGroup',
      activate: 'activateAppointmentTypeGroup',
      deactivate: 'deactivateAppointmentTypeGroup',
    },
  },
};

export const PATIENT_GROUP_RESOURCE_LIST = Object.values(PATIENT_GROUP_RESOURCE_TYPES);

const buildPatientGroupResourceActions = ({ actionTypes, endpoint, payloadKey }) => ({
  fetchList: (active = true) => crud({
    dispatch: {
      begin: actionTypes.FETCH_BEGIN,
      fail: actionTypes.FETCH_FAIL,
      end: actionTypes.FETCH_SUCCESS,
    },
    method: 'GET',
    url: `${endpoint}?active=${active}`,
  }),

  fetchOne: (id) => crud({
    dispatch: {
      begin: actionTypes.FETCH_ONE_BEGIN,
      fail: actionTypes.FETCH_ONE_FAIL,
      end: actionTypes.FETCH_ONE_SUCCESS,
    },
    method: 'GET',
    url: `${endpoint}/${id}`,
  }),

  create: (groupData, onSuccess) => crud({
    dispatch: {
      begin: actionTypes.CREATE_BEGIN,
      fail: actionTypes.CREATE_FAIL,
      end: actionTypes.CREATE_SUCCESS,
    },
    method: 'POST',
    url: endpoint,
    data: { [payloadKey]: groupData },
    onSuccess,
  }),

  update: (id, groupData, onSuccess) => crud({
    dispatch: {
      begin: actionTypes.UPDATE_BEGIN,
      fail: actionTypes.UPDATE_FAIL,
      end: actionTypes.UPDATE_SUCCESS,
    },
    method: 'PATCH',
    url: `${endpoint}/${id}`,
    data: { [payloadKey]: groupData },
    onSuccess,
  }),

  activate: (id, onSuccess) => crud({
    dispatch: {
      begin: actionTypes.ACTIVATE_BEGIN,
      fail: actionTypes.ACTIVATE_FAIL,
      end: actionTypes.ACTIVATE_SUCCESS,
    },
    method: 'PATCH',
    url: `${endpoint}/${id}/activate`,
    onSuccess,
  }),

  deactivate: (id, onSuccess) => crud({
    dispatch: {
      begin: actionTypes.DEACTIVATE_BEGIN,
      fail: actionTypes.DEACTIVATE_FAIL,
      end: actionTypes.DEACTIVATE_SUCCESS,
    },
    method: 'PATCH',
    url: `${endpoint}/${id}/deactivate`,
    onSuccess,
  }),
});

const codeGroupActions = buildPatientGroupResourceActions(PATIENT_GROUP_RESOURCE_TYPES.diagnosis_code);
const appointmentTypeGroupActions = buildPatientGroupResourceActions(PATIENT_GROUP_RESOURCE_TYPES.appointment_type);

export const fetchCodeGroups = codeGroupActions.fetchList;

export const fetchSmsProfiles = () => crud({
  dispatch: {
    begin: RECAPTURE_SMS_PROFILES.FETCH_BEGIN,
    fail: RECAPTURE_SMS_PROFILES.FETCH_FAIL,
    end: RECAPTURE_SMS_PROFILES.FETCH_SUCCESS,
  },
  method: 'GET',
  url: '/api/v1/recapture_sms_profiles',
});

export const fetchCodeGroup = codeGroupActions.fetchOne;
export const createCodeGroup = codeGroupActions.create;
export const updateCodeGroup = codeGroupActions.update;
export const activateCodeGroup = codeGroupActions.activate;
export const deactivateCodeGroup = codeGroupActions.deactivate;

export const fetchAppointmentTypeGroups = appointmentTypeGroupActions.fetchList;
export const fetchAppointmentTypeGroup = appointmentTypeGroupActions.fetchOne;
export const createAppointmentTypeGroup = appointmentTypeGroupActions.create;
export const updateAppointmentTypeGroup = appointmentTypeGroupActions.update;
export const activateAppointmentTypeGroup = appointmentTypeGroupActions.activate;
export const deactivateAppointmentTypeGroup = appointmentTypeGroupActions.deactivate;

// ============ SELECTORS ============

export const selectAppointmentTypeGroups = (state) => (
  state.patientRecapture?.appointmentTypeGroups || []
);

export const selectAppointmentTypeGroupById = (state, id) => (
  (state.patientRecapture?.appointmentTypeGroups || []).find((g) => g.id === id) || null
);

export const selectCodeGroups = (state) => (
  state.patientRecapture?.codeGroups || []
);

export const selectCodeGroupById = (state, id) => (
  (state.patientRecapture?.codeGroups || []).find((g) => g.id === id) || null
);
